
import "../Challenges.css"
import React, { useState,useEffect } from "react";
import api from "views/auth/Api";
import { Link } from "react-router-dom";
import Points from "./points"
import { API_BASE_URL } from '../../../../configs/AppConfig';
import { FILES_URL } from '../../../../configs/AppConfig';
import Loader from "components/loader";


const MyChallanges = () => {

      const [data , setData] = useState([]);
      const [page, setPage] = useState(1);
      const [totalPages, setTotalPages] = useState(1);
      const [loading, setLoading] = useState(false);
      
      const getData = async()=>{
        setLoading(true);
        await api.get(`${API_BASE_URL}assigned-challenge/`)
      .then(function (response) {
          setLoading(false);
            setData(response.data?.items)
             setTotalPages(response.data.totalPages);
      }).catch(error => {
        console.log("handlesubmit error for blog get ", error)
      });
      }  
      useEffect(()=>{ 
        getData();
      },[]);
  

  return (
    <div className="MyChallenges">
      <div className="mainMyHead">
      <div className="myHead">
        <div></div>
        <h2>My Challenges</h2>
      </div>
      {/* <div className="teamPoints">
              <div className="points-img"></div>
              <div className="points-text">
                <span>20</span>
                <span>Pts</span>
              </div>
            </div> */}
    {/* <div class="loyalty-card">
    <h4>Points Balance</h4>
    <div class="points-section">
      <div class="circle">
        🏆
      </div>
      <div class="points-text">
        <h1>1240pts</h1>
        <p>Collect points by end your challanges</p>
      </div>
    </div>
  </div> */}
  <Points/>
      </div>
      <div className="challangesDesc">
        <div className="challangeslist">
          {/* <h3>New Challenges</h3> */}
          <div className="challanges-continar">
            { loading ? <Loader loading={loading} /> : !data[0] && !loading ? <span>NO Projects Available</span> : null}
            {data.map(challenge => <Link to={`/admin/challenges/create/${challenge.id}`} >
            <div className="challangesCards">
            <div className="cardImg-ch" style={{backgroundImage:`url(${FILES_URL}${challenge.challenge?.img?.url})`}}></div>
            <div className="cardInfo-ch">
                <h4>{challenge.challenge?.challengeTitle}</h4>
                <span>{challenge.points} Points</span>
                <p>{challenge.challenge?.subject}</p>
                <p>{challenge.dueDate?.substring(0, 10)}</p>
                 <button>Start</button>
               
              </div>
          </div> </Link>)}
          </div>
        </div>

        {/* <div className="rightChallanges">
            <div className="teamsTop">
              <h2 className="top-H2">Top This Week</h2>
             
           <div className="teamWeek">
                {data.map((project,index) =>
            <div className="top4">
                <span>#{index+1}</span>
                <div className="animation-team"></div>
                <span>{project.userName}</span>
            </div>)}

              </div>
            </div>
            <div className="teamPoints">
              <div className="points-img"></div>
              <div className="points-text">
                <span>Your Points</span>
                <span>20</span>
              </div>
            </div>
        </div> */}
      </div>
      {!data[0] ? null : <div className="flex items-center justify-center mt-6 mb-4 gap-3 bottom-0 ">
        <button
          className="px-4 py-2 bg-gray-200 rounded-lg disabled:opacity-50"
          disabled={page === 1}
          onClick={() => setPage((p) => p - 1)}
        >
          Previous
        </button>

        {[...Array(totalPages)].map((_, i) => (
          <button
            key={i}
            className={`min-w-[40px] px-3 py-2 rounded-lg ${
              page === i + 1
                ? "bg-blue-600 text-white"
                : "bg-gray-200 hover:bg-gray-300"
            }`}
            onClick={() => setPage(i + 1)}
          >
            {i + 1}
          </button>
        ))}
        <button
          className="px-4 py-2 bg-gray-200 rounded-lg disabled:opacity-50"
          disabled={page === totalPages}
          onClick={() => setPage((p) => p + 1)}
        >
          Next
        </button>
      </div>}
    </div>
  );
};

export default MyChallanges;
